import styled from 'styled-components'

export const TableScrollWrapper = styled.div`
  overflow-x: auto;
  width: 100%;

  @media (max-width: 768px) {
    display: none;
  }
`

export const ConnectionCardList = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
`

export const ConnectionCard = styled.div`
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 16px;
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
`

export const CardStartupLink = styled.span`
  font-family: 'Caixa Std';
  font-size: 14px;
  font-weight: 600;
  color: var(--primary);
  text-decoration: underline;
  cursor: pointer;
  word-break: break-word;
`

export const CardBadge = styled.span`
  font-family: 'Caixa Std';
  font-size: 12px;
  font-weight: 500;
  color: var(--primary);
  background: #E8F1FA;
  border-radius: 4px;
  padding: 2px 8px;
  white-space: nowrap;
  flex-shrink: 0;
`

export const CardRow = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 6px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const CardLabel = styled.span`
  font-family: 'Caixa Std';
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
  white-space: nowrap;
`

export const CardValue = styled.span`
  font-family: 'Caixa Std';
  font-size: 12px;
  font-weight: 400;
  color: var(--text-primary);
  word-break: break-word;
`
